export default "__VITE_ASSET__CFlHvObu__"